import { render, staticRenderFns } from "./cpsjj.vue?vue&type=template&id=25581234&scoped=true&"
import script from "./cpsjj.vue?vue&type=script&lang=js&"
export * from "./cpsjj.vue?vue&type=script&lang=js&"
import style0 from "./cpsjj.vue?vue&type=style&index=0&id=25581234&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25581234",
  null
  
)

export default component.exports